import React from 'react'
import { InputStyle } from './styles'

export interface InputProps {
  value: string
  maxLength: number
  onChange: (e: any) => void
  error: boolean
  isActive: boolean
}

export const Input = ({ maxLength, onChange, error, value, isActive }: InputProps) => {
  return (
    <InputStyle
      readOnly
      isActive={isActive}
      type="text"
      name="currentPage"
      value={value}
      maxLength={maxLength}
      onChange={onChange}
      autoComplete="off"
      error={error}
      // onKeyUp={e => {
      //   e.key === 'Enter' && console.log('Enter')
      // }}
      onClick={onChange}
    />
  )
}
